export default {
	termsAndConditions: {
		lastUpdate: 'Son güncelleme: 10 Haziran 2024',
		content: `
		<p>Aşağıda bulacağınız Şartlar önemlidir çünkü:</p>
		<ul>
			<li>{siteName} sitesinde yasal haklarını tesis ederler.</li>
			<li>{siteName} sitesini kullandığınızda bize verdiğiniz hakları açıklayın.</li>
			<li>
				{siteName} kullanırken herkesin uyması gereken kuralları açıklarlar.
			</li>
		</ul>
		<p>
			Lütfen bu Şartları ve ayrıca {privacyPolicyLink} ve diğer koşulları dikkatlice okuyun.
			bu Koşullarda belirtilen belgeler.
		</p>
		<p>Haydi başlayalım...</p>
		<h3>1. {siteNameUpper} GİRİŞİ VE VERİLERİ.</h3>
		<p>
			{websiteLink} web sitesi (bundan böyle "Web Sitesi" olarak anılacaktır) şirkete aittir
			{siteName} S.L (bundan sonra "{siteName}" olarak anılacaktır), Bir şirket
			İspanyol mevzuatına uygun olarak Avenida de adresiyle kurulmuştur.
			Cerdanyola, n° 75, 1°, Sant Cugat del Vallès (Barselona), CIF numarası sahibi
			B-56.768.260 ve Barselona Ticaret Siciline Cilt olarak kayıtlıdır
			49065, Folio 0033, Sayfa B-606324, 1. Kayıt.
		</p>
		<p>
			{siteName}, erişebilmeniz için Web Sitesini kullanımınıza sunuyor
			Bizi daha iyi tanıyın, verdiğimiz hizmetleri öğrenin ve dilerseniz iletişime geçebilirsiniz.
			ve uygun olduğu durumlarda bizimle sözleşme yapın.
		</p>
		<h3>2. KULLANIM KOŞULLARININ UYGULAMA AMACI VE KAPSAMI</h3>
		<p>
			Bu kullanım koşulları, {privacyPolicyLink} ve
			{cookiesPolicyLink}, web sitesinin kullanımını düzenleyen yasal çerçeve
			{websiteLink}. Bu kullanım koşulları web sitesinde kullanımınıza sunulacaktır
			İngilizce olarak istediğiniz zaman başvurabilmeniz, arşivleyebilmeniz veya yazdırabilmeniz için
			ne zaman istersen.
		</p>
		<p>
			{siteName} tarafından gerçekleştirilen tedaviye ilişkin sorularınızı öğrenmek için.
			kişisel verileriniz için lütfen {privacyPolicyLink} ve {cookiesPolicyLink} sayfalarımızı ziyaret edin.
			Her iki politika da İngilizce olarak size sunulacaktır, böylece
			istediğiniz zaman bunlara başvurun, arşivleyin veya yazdırın.<br />
			{siteName}, Web Sitesinde üçüncü taraf çerezleri kullanır. Daha fazla bilgi edinmek için
			{websiteLink} webinde kullanılan çerezlerin türü, amaçları ve nasıl kullanıldığı hakkında
			Bu çerezleri kullanmamızı istememeniz durumunda tarayıcınızı yapılandırmak için,
			lütfen {cookiesPolicyLink} sayfamızı ziyaret edin.
		</p>
		<p>
			Hem bu kullanım koşulları hem de {privacyPolicyLink} ve 
			{cookiesPolicyLink} yürürlükteki hükümlere uygun olarak hazırlanmıştır.
			geçerli düzenlemeler, diğerlerinin yanı sıra, Hizmetlere ilişkin 34/2002 sayılı Kanun
			Bilgi Toplumu ve Elektronik Ticaret ve Düzenleme (AB) 2016/679
			Avrupa Parlamentosu ve Konseyinin 27 Nisan 2016 tarihli kararı,
			kişisel verilerin işlenmesiyle ilgili olarak gerçek kişilerin korunması
			veriler ve bu verilerin serbest dolaşımı ve hangi Direktif 95/46/CE
			yürürlükten kaldırılmıştır.
		</p>
		<h3>3. WEB SİTESİNE ERİŞİM VE KABUL</h3>
		<p>
			Web Sitesine erişim, ücrete ilişkin kısım dışında ücretsizdir.
			İnternet tarafından sağlanan telekomünikasyon ağı üzerinden bağlantı
			anlaşmalı olduğunuz erişim sağlayıcısı. Web Sitesine özgürce göz atabilirsiniz
			ve ona istediğiniz kadar erişin. Web Sitesine erişmek ve gezinmek için,
			Bir hizmet kiralamak istemeniz dışında kayıt olmanıza gerek yoktur.
		</p>
		<p>
			Web sitesinin kullanımı size web sitesinin kullanıcısı olma koşulunu verir
			(bundan böyle "Kullanıcı" olarak anılacaktır) ve aşağıdakileri tam ve kayıtsız şartsız kabul ettiğinizi ima eder:
			bu kullanım koşullarının yanı sıra {privacyPolicyLink} ve {cookiesPolicyLink}
			Web Sitesinin. Ayrıca Hizmeti yasa dışı amaçlarla kullanmamayı kabul edersiniz.
			amaçlar.
		</p>
		<p>
			Web Sitesine erişerek ve burada gezinerek, kendi yetkiniz altında beyan edersiniz.
			reşit olduğunuzun ve gerekli yasal niteliklere sahip olduğunuzun sorumluluğu
			Web Sitesine erişme ve onu kullanma yetkisine sahip olduğunuzu ayrıca tam olarak beyan ettiğinizi beyan edersiniz.
			bu kullanım koşullarını çekincesiz anlayın ve kabul edin.
		</p>
		<p>
			Öte yandan yasal nedenlerden dolayı arşivlediğimizi de bildiririz.
			satın almaların resmileştirildiği elektronik belgeler. Bağlanabilirsin
			Bu belgeleri istediğiniz zaman şu adresten talep edebilirsiniz: {supportLink}.
		</p>
		<h3>4. WEB SİTESİNİN KULLANIM KOŞULLARI</h3>
		<p>
			Kullanıcı, Web Sitesini bu kullanım koşullarına uygun olarak kullanmayı kabul eder,
			Mevcut mevzuat ve iyi niyet. Böylece Kullanıcı {siteName}'e yanıt verecektir.
			 ve bundan kaynaklanan zarar ve ziyanlar için herhangi bir üçüncü şahıs önünde
			bu şartlara, mevzuata ve iyi niyet kurallarına aykırı kullanım
			Web Sitesinin Kullanıcısı tarafından.
		</p>
		<h3>5. HİZMETİN AÇIKLAMASI</h3>
		<p>
			{siteName}, Hizmet aracılığıyla hizmete aboneliğe izin verir:
			görüntü düzenleme işlemini gerçekleştirin.
		</p>
		<p>
			{siteName} ile alıcı arasındaki sözleşmenin dili
			menşe ülke olduğu sonucuna varılacaktır.<br />
			Çevrimiçi hizmetteki satın alma süreci aşağıdaki gibi olacaktır:
		</p>
		<ol>
			<li>Web sitesine kullanıcı adı ve şifreyle kayıt olmalısınız.</li>
			<li>
				Kayıt sırasında kullanıcının ödeme planlarından birini seçmesi gerekir.
				Fiyatlar bölümünde bulunur ve fiyatlara bağlı olarak kredi verilecektir.
				seçilen plan. Her kredi bir resmi düzenlemenize olanak tanır.
			</li>
			<li>
				Hizmeti satın aldıktan sonra kullanıcı bir yönetime sahip olacaktır.
				Bulabilecekleri panel:
				<ul>
					<li>
						İşlenen tüm görüntülerin listesini içeren bir bölüm
						istediğiniz kadar düzenleyebilir ve bilgisayarınıza indirebilirsiniz
						cihaz.
					</li>
					<li>
						Faturalara bakmak ve iptal etmek için Planlar ve ödemeler bölümü
						abonelik.
					</li>
					<li>Hesap tercihlerini değiştirebileceğiniz Hesabım bölümü.</li>
				</ul>
			</li>
		</ol>
		<p>
			Hizmetin satın alınması yapıldıktan sonra onaylanacaktır.
			en geç 24 saat içinde sahip olduğunuz adrese e-posta göndermek
			belirtilen. Hizmeti, aboneliğin nasıl iptal edileceğini,
			tutar, geçerli vergiler, ödeme şekli ve geçerli şartlar ve
			koşullar.
		</p>
		<h4>5.1 Abonelik</h4>
		<p>
			Hizmet aboneliği seçilen plana göre değişir ve
			sona erene kadar aynı süre için otomatik olarak yenilenir.
			Aboneliğinizi iptal etmediğiniz sürece, bize yükleme yetkisi vermiş olursunuz.
			ödeme yönteminizde karşılık gelen yıllık abonelik ücreti.
		</p>
		<p>
			Hizmete olan aboneliğinizi istediğiniz zaman iptal edebilirsiniz;
			Yıllık fatura döneminizin sonuna kadar bu hesaba erişmeye devam edin. İle
			Yasaların izin verdiği ölçüde, ödemeler iade edilemez ve
			Kısmi yıllık abonelik dönemleri için geri ödemeler veya krediler.
		</p>
		<h3>6. FİYAT VE VERGİLER</h3>
		<p>
			{siteName} sitesinde sunulan ürünlerin fiyatları euro cinsinden belirtilmiştir
			(€) veya satın alma işleminin yapıldığı ülkenin para birimi, Değer
			Satın alma anında yürürlükte olan Katma Vergi (KDV), ürünün fiyatına uygulanır.
			ürünler.
		</p>
		<p>
			Her durumda, işlem duruma bağlı olarak KDV'den muaf olabilir veya KDV'ye tabi olmayabilir.
			ikamet ettiğiniz ülke veya hareket ettiğiniz durum. Bu yüzden,
			bazı durumlarda emrin nihai fiyatı, siparişin türüne göre değiştirilebilir.
			biri gösterilmiştir.<br />
			KDV ödemesinden muaf olan kişiler tarafından yapılan satın alımlar bunu şu şekilde belirtecektir:
			KDV/NIF numaralarını kaydetmeden e-postayla {supportLink}'a gönderme
			söz konusu vergi ile satın almalar.
		</p>
		<h3>7. ÖDEME YÖNTEMİ</h3>
		<p>
			Satın alınan hizmetin ödemesi online olarak kredi kartı veya banka kartı ile yapılabilmektedir.
			Bu anlamda {siteName}, kredi ve banka kartı sahiplerini şu şekilde bilgilendirir:
			çevrimiçi mağazadaki işlemler güvenli bir ödeme yoluyla gerçekleştirilir
			Ağ geçidi, veri aktarımının güvenliğini garanti etmek için SSL teknolojisini kullanır.
		</p>
		<h3>8. CAYMA VE İADE HAKKI</h3>
		<h4>8.1. Cayma hakkı</h4>
		<p>
			Çevrimiçi hizmetimizde pazarlanan ürünün türü göz önüne alındığında, dijital ortamda yazılım
			QR formatında cayma hakkı geçerli olmayacaktır.
			16 Kasım tarihli 1/2007 sayılı Kraliyet Kanun Hükmünde Kararnamenin 103. maddesi, m harfi)
			Tüketicinin Korunması Hakkında Genel Kanun'un revize edilmiş metni ve
			Kullanıcılar ve diğer tamamlayıcı yasalar onaylanmıştır.
		</p>
		<h4>8.2. Geri ödemeler</h4>
		<p>
			Kullanıcının seçtiği plan ne olursa olsun ödediği tutarlar ve
			kanunların izin verdiği ölçüde iade edilmeyecektir.
		</p>
		<p>
			Sözleşme konusu hizmet başka kullanıcılara devredilemez ve devredilemez.
			hizmet.
		</p>
		<p>
			Kullanıcı her durumda sözleşme konusu hizmetten süresi sonuna kadar yararlanabilir.
			sözleşmeli dönem.
		</p>
		<h3>9. TEKLİFLERİN GEÇERLİLİĞİ</h3>
		<p>
			Hizmette sunulan hizmetler ve bunların fiyatları,
			bu aracılığıyla görüntülenen hizmet kataloğundayken satın alın
			İnternet sitesi.
		</p>
		<p>
			Her durumda {siteName}, istediği değişiklikleri yapma hakkını saklı tutar.
			Hizmette uygun gördüğü ürün ve hizmetleri güncelleyebilme
			pazara bağlı olarak.
		</p>
		<p>
			{siteName} önceden bildirimde bulunmaksızın fiyatları değiştirme hakkını saklı tutar. Biz
			fiyatlarında yapılan güncellemelere rağmen sizi bilgilendirmek
			Servis, hatalar içerebilir. Herhangi bir hatayı derhal düzelteceğiz
			görünür ancak bunlar Hizmet açısından bağlayıcı olmayacaktır.
		</p>
		<h3>10. GÜVENLİK</h3>
		<p>
			Yukarıda belirtildiği gibi, tüm satın alma prosedürünün yanı sıra iletim
			Kişisel verilerinizin ve ödeme sistemlerinizin işlenmesi güvenli bir sayfada gerçekleştirilir ve
			SSL protokolü aracılığıyla şifrelenmiş bir şekilde.
		</p>
		<p>
			Mevcut mevzuata uygun olarak Hizmetin güvenliğini garanti ediyoruz
			teknolojik bilgi. Ancak {siteName} sitenin tamamını garanti edemez
			Hizmetin gelecekteki güvenliği. Her durumda, düzeltmeye söz veriyoruz ve
			olası bir güvenliği düzeltmek için uygun düzeltici önlemleri uygulamak
			ihlalin mümkün olan en kısa sürede giderilmesi.
		</p>
		<p>
			{siteName}'ı derhal ve e-posta {supportLink} yoluyla bilgilendirmeyi kabul ediyorsunuz
			Kullanıcının kimliğinin taklit edilmesine yol açabilecek herhangi bir durum.
		</p>
		<h3>11. DEĞİŞİKLİKLER VE GEÇERSİZLİK</h3>
		<p>
			Gelecekte Hizmetin hüküm ve koşullarını da güncelleyebiliriz
			Hizmetin kendisinin özellikleri ve işlevleri olarak.
		</p>
		<p>
			Şartlar ve koşullardaki değişiklikler hakkında sizi bir bildirimde bulunarak bilgilendireceğiz
			web sitemizde göze çarpan bir yere ve/veya e-posta yoluyla.
		</p>
		<p>
			Bu hüküm ve koşullarda yer alan herhangi bir maddenin tamamen veya
			kısmen, hükümsüz veya etkisiz ise, yalnızca söz konusu hükmü veya ilgili kısmı etkileyecektir.
			geçersiz veya etkisizdir. Şartlar ve koşullar geçerli olacaktır
			bu tür bir hükme sahip olan diğer her şey veya bunun etkilenen kısmı
			yerleştirilmiyor.
		</p>
		<h3>12. SÖZLEŞMEDEN KAYNAKLANAN İDDİALAR VE DAVALAR</h3>
		<p>
			Bu Hizmet mümkün olduğu ölçüde İspanyol yasalarına tabidir.<br />
			İddiaların hukuk davaları yoluyla çözümlenmesini kolaylaştırmak amacıyla ve
			maliyetleri düşürmek için kendimizi bir yönetime teslim etme olasılığını dışlamıyoruz.
			Ticaret Odaları Tahkim Mahkemesinin Hakkaniyet Tahkimi ve
			Sanayi. Bu anlamda ve ilgili mevzuata göre;
			 {siteName}, Avrupa'da çevrimiçi bir anlaşmazlık çözümünün varlığını bildiriyor
			Bu tür anlaşmazlıkların mahkeme dışında çözümünü kolaylaştıran bir platform
			sözleşmeler aynı zamanda tüketiciler ve İnternet hizmeti arasında çevrimiçi olarak da akdedilmektedir.
			sağlayıcılar. Bu platforma aşağıdaki web sitesinden ulaşılabilir:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. FİKRİ VE SINAİ MÜLKİYET HAKLARI</h3>
		<p>
			Web Sitesi ve içeriği, aşağıdaki hükümlerin uygulanması halinde korumaya tabidir:
			Fikri ve/veya Sınai Mülkiyete ilişkin mevcut ulusal düzenlemeler,
			ve bu gibi durumlarda geçerli olan uluslararası sözleşmelerin uygulanmasında
			önemli. {siteName}, tüm sitelerin sahibidir veya usulüne uygun lisansa sahiptir.
			İnternet Sitesi ve içeriğindeki Fikri ve Sınai Mülkiyet hakları.
		</p>
		<p>
			Her türlü çoğaltma, dağıtım, kamusal iletişim, dönüştürme,
			kullanılabilir hale getirme ve genel olarak başka herhangi bir sömürü eylemi
			Web Sitesinin veya içeriğinin ticari amaçları için, önceden izin alınmaksızın
			{siteName}'nin açık rızası. silinmesi kesinlikle yasaktır.
			{siteName} verilerinin Fikri Mülkiyet sahibi olarak tanımlanması ve
			Web Sitesinin veya içeriğinin Sınai Mülkiyet hakları.
		</p>
		<p>
			{siteName} tüm Fikri ve Sınai Mülkiyet haklarını saklı tutar
			Web Sitesi ve içeriği üzerinde, ayrıca her türlü yasal işlem saklı tutularak
			herhangi bir eylemi durdurmak, önlemek veya kovuşturmak için buna karşılık gelen eylemler
			Web Sitesinin veya içeriğinin yasa dışı kullanımı. Hiçbir durumda ve hiçbir durumda
			koşullar altında Web Sitesine erişim veya Kullanıcı tarafından kullanılması veya üçüncü
			taraflar {siteName} tarafından herhangi bir tür devir teşkil eder veya ima eder
			Web Sitesinin veya içeriğinin Fikri veya Sınai Mülkiyet hakları.
			Hiçbir durumda {siteName} tarafından bu sitenin kullanımını durdurma zorunluluğunun bulunmaması
			Web sitesi veya yasa dışı veya bu koşullara aykırı içerik,
			{siteName} tarafından bu tür kullanımlara yönelik zımni onay veya feragat olarak anlaşılmalıdır
			buna karşılık gelebilecek herhangi bir yasal işlemin uygulanması.
		</p>
		<h3>14. SORUMLULUKLAR VE GARANTİLER</h3>
		<p>
			Kullanıcı, Web Sitesini ve içeriğini aşağıdaki hükümlere uygun olarak kullanmalıdır:
			bu kullanım koşullarının hükümleri, yürürlükteki mevzuat ve iyi niyet. Herhangi
			Web sitesinin veya içeriğinin bu genel koşullara aykırı kullanılması,
			Söz konusu kullanımın hukuka aykırı olup olmadığına bakılmaksızın, kanun veya iyi niyetle açıkça yasaklanmıştır.
			ekonomik bir amaç olsun ya da olmasın.<br />
			{siteName}'nin neden olduğu her türlü hasar veya zarardan Kullanıcı sorumlu olacaktır.
			 veya herhangi bir kullanımdan doğrudan veya dolaylı olarak elde edilen üçüncü taraflara
			Kullanıcının Web Sitesinden veya içeriğinden bunlara aykırı hareket etmesi
			koşullar, hukuk, ahlak, kamu düzeni veya iyi niyet.
		</p>
		<p>
			Web Sitesinin ve içeriğinin Kullanıcı tarafından erişilebilir olması için, {siteName}
			 üçüncü şahıslar tarafından sağlanan hizmetleri gerektirir. bu mümkün
			{siteName} tarafından Web Sitesini kullanılabilir durumda tutmak için gösterilen çabalara rağmen
			ve kullanıcılar tarafından erişilebilir olduğundan, kullanılabilirliği askıya alınabilir, kesintiye uğratılabilir veya
			{siteName} dışındaki nedenlerden dolayı iptal edildi. Bu nedenle {siteName}
			erişimde kesinti veya hata olmayacağını garanti etmez.
			Web sitesi veya içeriğinin güncellenmemesi veya her zaman görüntülenmemesi
			onların en son sürümü. Sonuç olarak, {siteName} herhangi bir talebi reddeder
			Kullanıcıya veya üçüncü kişilere gelebilecek zararlardan dolayı sorumluluk kabul edilmez.
			askıya alma, kesinti, süreklilik eksikliği, ağ kesintisi sonucu
			veya Web Sitesinin bağlantısının kesilmesi.
		</p>
		<p>
			{siteName} hiçbir durumda ve hiçbir koşulda şunlardan sorumlu olmayacaktır:
			{siteName} ile ilişkilendirilemeyen nedenlerden dolayı kullanıcıya kaynaklanan hasarlar veya kayıplar
			 örnek olarak ve hiçbir durumda sınırlayıcı olmayan doğal
			afetler, mücbir sebep veya aşırı acil durumlar, virüsler, zararlı
			bileşenler, tarayıcı arızaları, ağ kesintileri, bilgisayara izinsiz girişler veya
			üçüncü taraf saldırıları.
		</p>
		<h3>15. BAĞLANTILAR</h3>
		<p>
			Web siteleri, platformlar, forumlar, sohbetler, bloglar veya harici sosyal ağlar
			Web Sitesine bağlantı veya bağlantıya sahip olmadıklarını açıkça bildirmelidirler.
			{siteName} sitesinin yetkilendirilmesi veya denetlenmesi ve söz konusu bağlantının veya
			bağlantı, {siteName} arasında herhangi bir türde ilişki gerektirmez, varsaymaz veya ima etmez
			 ve web siteleri, platformlar, forumlar, sohbetler, bloglar veya harici
			Web Sitesine bağlantı veren veya bağlantı veren sosyal ağlar.
		</p>
		<p>
			Her durumda, Web Sitesine yönlendirilen herhangi bir bağlantı yönlendirilmelidir.
			URL'ye tıklayarak doğrudan Web Sitesinin ana sayfasına veya ana sayfasına gidin
			web sitesinin ana sayfasının veya başlangıç sayfasının tüm ekranını kaplayan kısmı
			Web sitesi, bağlantı kullanılmadan mutlak ve eksiksiz olacak şekilde
			çerçeveler, çerçeveler veya köprüler. {siteName} hiçbir durumda yanıt vermiyor
			ve her koşulda ilgili içerik, bilgi veya verilere
			Web sitesi, içeriği veya web sitelerinde, platformlarda yer alan diğer hususlar,
			bağlantı veren veya bağlantı veren forumlar, sohbetler, bloglar veya üçüncü taraf sosyal ağlar
			İnternet sitesi.
		</p>
		<p>
			Web sitelerinden Web Sitesine bağlantı verilmesi veya bağlantı verilmesi açıkça yasaktır,
			Yasalara, ahlaka aykırı platformlar, forumlar, sohbetler, bloglar veya sosyal ağlar
			ve iyi gelenekler, özellikle pornografik, yasadışı, yasa dışı veya
			İnsan haklarını ihlal eden içerik.
		</p>
		<p>
			Öte yandan, Web Sitesi üçüncü taraf web sitelerine bağlantılar içerebilir,
			platformlar, forumlar, sohbetler, bloglar veya sosyal ağlar. {siteName} bunu yapmıyor
			bilgileri bilmek veya kontrol etmek için insani ve/veya teknik araçlara sahip olmak ve
			üçüncü taraf web sitelerinde görünen içerik. Bu nedenle hiçbir durumda {siteName}
			 Bağlantı verilen sitelerin içeriğinden sorumlu olacak ve hiçbir şekilde
			koşullar söz konusu bağlantıların içerikle ilgili etkili bilgi olarak değerlendirilebileceğini
			bağlantı verdikleri siteler.
		</p>
		<h3>16. VERİ KORUMASI</h3>
		<p>
			{privacyPolicyLink}'te belirtildiği üzere, {siteName}, Kullanıcı'yı kullanmayı taahhüt eder.
			verilerin gizliliğine saygı göstermeyi ve bunları yasalara uygun olarak kullanmayı
			tedavinin amacı ve onu kurtarma yükümlülüğüne uymaktır.
			ve değişiklik, kayıp, muamele veya yetkisiz muameleyi önlemek için tüm tedbirleri uyarlayın.
			erişime ilişkin yürürlükteki mevzuat hükümlerine uygun olarak
			kişisel verilerin korunması.
		</p>
		<p>
			Web Sitesi uygun önlemleri içerir ve endüstri standartlarını kullanır
			güvenliği, bütünlüğü, bütünlüğü, doğruluğu ve doğruluğu geliştirmek için teknoloji
			Topladığı kişisel verilerin korunmasını tesis etmiş ve
			bu bilgiyi olası kayıplardan veya kayıplardan korumak için makul önlemler
			yanlış kullanım. Veri koruma ve güvenliğe ilişkin kuralları periyodik olarak gözden geçirilmektedir
			gerektiğinde geliştirilir ve yalnızca yetkili kişilerin kullanımına sunulması için çaba gösterilir.
			kişiler, Kullanıcı tarafından sağlanan bilgilere erişebilir.
		</p>
		<p>
			{siteName} tarafından gerçekleştirilen yönetim ve işleme hakkında daha fazla bilgi edinmek için
			 verilerinizin korunması için lütfen {privacyPolicyLink} ve {cookiesPolicyLink} sayfalarımızı okuyun.
		</p>
		<h3>17. SÜRE VE DEĞİŞİKLİK</h3>
		<p>
			Bu kullanım koşulları, maruz kaldıkları süre boyunca yürürlükte kalacaktır.
			tamamen veya kısmen değiştirildiği veya güncellendiği anda,
			bu koşullar yeni kullanım koşulları olduğundan yürürlükten kalkacaktır
			Web Sitesinin kullanımını düzenleyenler.
		</p>
		<p>
			{siteName} bunları inceleme, değiştirme veya güncelleme hakkını saklı tutar
			herhangi bir zamanda kullanım koşulları. Bu koşullarda herhangi bir değişiklik olması durumunda
			{siteName}, herhangi bir nedenle kullanımdan vazgeçerse, kullanıcıları ana sayfasında bilgilendirecektir.
			usulüne uygun olarak bilgilendirilmeleri ve danışabilmeleri için söz konusu durum hakkında web
			mevcut kullanım koşullarındaki revizyonlar, değişiklikler veya güncellemeler
			Memnuniyetiniz.
		</p>
		<h3>18. GENEL</h3>
		<p>
			Hiçbir durumda ve hiçbir koşulda haklarınızın kullanılmaması söz konusu olamaz.
			{siteName} tarafından bunlardan feragat edildiği anlaşılmalıdır.
		</p>
		<p>
			Bu koşullarda yer alan başlıklar yalnızca yol göstericidir veya
			yorumu etkilemeyecek, nitelendirmeyecek veya genişletmeyecek şekilde bilgilendirici
			bundan.
		</p>
		<p>
			Bu şartlarda yer alan maddelerden herhangi birinin mevcut olması durumunda
			bir yargı mercii tarafından tamamen veya kısmen hükümsüz, istismar edici veya uygulanamaz ilan edildi
			veya idari organ, söz konusu beyan, maddeyi tek başına etkileyecektir.
			söz konusu olduğunda, geçersiz sayılarak ve geçersizlik, suiistimal veya
			uygulanamazlık her koşulda geri kalanını da kapsayacak şekilde genişletilir.
			varlığını sürdürecek koşullar.
		</p>
		<p>
			Bu kullanım koşullarının yanı sıra {privacyPolicyLink} ve {cookiesPolicyLink}
			her zaman mevcut İspanyol düzenlemelerine tabidir.
		</p>
		<h3>19. MÜŞTERİ HİZMETLERİ</h3>
		<p>
			Herhangi bir açıklama, olay veya iddia için bizimle şu adresten iletişime geçebilirsiniz:<br />
			E-posta: {supportLink}<br />
			Posta adresi: Av. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, Barselona, İspanya.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Son güncelleme: 10 Haziran 2024',
		content: `
			<h3>1. Sorumlu taraf ve açıklama</h3>
			<h5>1.1. Sorumlu</h5>
			<p>Bu sitenin işlenmesinden sorumlu kişi Arka Planı Kaldır S.L'dir (bundan sonra Arka Planı Kaldır olarak anılacaktır) 
			veya Hizmet), adresi Av. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, Barselona, İspanya.</p>
			<p>NIF: B56768260<br> E-posta: {supportLink}</p>

			<h5>1.2. Açıklama</h5>
			<p>Arka Planı Kaldır gizlilik politikasının (bundan sonra "Gizlilik Politikası" olarak anılacaktır) kabul edilmesi gerekli bir durumdur 
				Web sitemizin kullanımı ve hizmetin (bundan böyle "Hizmet" olarak anılacaktır) sağlanması için.<br>
				Bu Gizlilik Politikası, kişisel ve kişisel olmayan bilgilerinizin toplanmasını, işlenmesini ve kullanılmasını düzenler 
				başlıkta görünen geçerlilik tarihi itibarıyla Arka Planı Kaldır kullanıcısı olarak.<br>
				Kişisel verilerinizi işlemek için Arka Planı Kaldır, mevcut yerel ve Avrupa mevzuatına uygundur, 
				ve uygulama yönetmelikleri.</p>


			<h3>2. Toplanan bilgiler</h3>
			<p>Sitemize erişim, kayıt olmak ve/veya kayıt olmak kaydıyla herhangi bir bilgi vermenize gerek kalmadan yapılabilmektedir. 
				veya planlarımızı sözleşmeye bağlamak için bize bazı kişisel bilgiler vermeniz gerekecektir. Bilgiler (kişisel 
				Hizmet tarafından toplanan veya kişisel olmayan) buna bağlı olarak değişiklik gösterebilir.<br>
				Hizmet tarafından toplanan kişisel ve kişisel olmayan bilgiler bize üç şekilde ulaşacaktır: 1) 
				2) bize gönüllü olarak sağladığınız bilgiler ve 3) üçüncü taraflarca sağlanan bilgiler otomatik olarak toplanır.</p>

			<h5>2.1. Otomatik olarak toplanan</h5>
			<p>Bu bilgiler aşağıdakilerden oluşacaktır:</p>
			<ul>
				<li>Cihazınızda saklanan çerezler veya benzer mekanizmalar aracılığıyla, her zaman sizin izninizle veya 
					diğer yasal dayanaklara uygun olarak. Daha fazla bilgi için Çerez Politikamızı inceleyin.</li>
				<li>Bağlantının yapıldığı IP, kullanılan cihazın türü ve özellikleri, sürümü 
					isteğin işletim sistemi, tarayıcı türü, dili, tarihi, ülkesi, saati, 
					diğerlerinin yanı sıra geldiğiniz URL, gittiğiniz URL veya kullanılan mobil ağ.</li>
				<li>Hizmet kullanım verileri ve kullanımı sırasında tespit edilen olası hatalar.</li>
				<li>Ayrıca Arka Planı Kaldır, Google, LLC tarafından sağlanan bir analitik hizmet olan Google Analytics'i kullanır. 
					Amerika Birleşik Devletleri'nde ikamet etmektedir ve genel merkezi 1600 Amphitheatre Parkway, Mountain View, California 94043'tedir. 
					Bu hizmetlerin sağlanması için kullanıcının IP adresi de dahil olmak üzere bilgi toplayan çerezler kullanırlar, 
					Google tarafından www.google.com web sitesinde belirlenen şartlara göre iletilecek, işlenecek ve saklanacaktır. 
					Yasal gereklilik nedeniyle söz konusu bilgilerin üçüncü taraflara olası iletilmesi dahil veya 
					söz konusu üçüncü tarafların bilgileri Google adına işlemesi.</li>
			</ul>
			<p>Her durumda, Google Analytics çerezlerini <a href="{externalLink:disableGoogleAnalyticsLink}">buradan</a> devre dışı bırakabilirsiniz.</p>

			<h5>2.2. Gönüllü olarak sağladığınız</h5>
			<p>Bu bilgiler aşağıdakilerden oluşacaktır:</p>
			<ul>
				<li>Tüm veriler zorunludur.</li>
				<li>Web'deki kaydınızı tamamlamak için Arka Planı Kaldır'ın gerektirdiği bilgiler: diğerlerinin yanı sıra ad ve soyad, adres ve e-posta.</li>
				<li>Tüm veriler zorunludur.</li>
				<li>E-posta adresiniz ve kredi veya banka kartı numaranız gibi hizmet sözleşmesinin tamamlanmasına yönelik kişisel olsun ya da olmasın bilgiler.</li>
				<li>Hizmet'te oluşturulan iletişim veya görüş kanalları aracılığıyla gönderilen mesajların içerebileceği kişisel veya kişisel olmayan bilgiler, 
					örneğin adınız ve e-posta adresiniz.</li>
			</ul>

			<h5>2.3. Üçüncü tarafların sağladığı</h5>
			<p>Bu bilgiler aşağıdakilerden oluşacaktır:</p>
			<ul>
				<li>Satın alma zamanı veya tutarı gibi ödeme sistemleri veya kredi kartı işlemcileri tarafından sağlanan bilgiler.</li>
			</ul>


			<h3>3. Haklar ve amaçlar</h3>
			<p>Formların doldurulmasının isteğe bağlı olduğunu size bildiririz. Ancak gerekli alanları doldurmazsanız 
				(genellikle bir yıldız işaretiyle işaretlenir), Hizmetin bazı işlevlerinin kullanımı mümkün olmayacak veya sınırlı olacaktır.<br>
				Bize sağladığınız kişisel veriler, Geçmişi Kaldırma Tedavi Faaliyetleri Kaydına dahil edilecek ve işlenecektir. 
				taleplerinizi karşılayabilmek, talep edilen hizmeti sağlayabilmek ve faaliyetle ilgili konularda sizleri bilgilendirebilmek amacıyla 
				şirketin ve hizmetlerinin.<br>
				Tedavinize erişim, düzeltme, silme, sınırlandırma haklarınızı istediğiniz zaman kullanabilirsiniz, 
				{supportLink} adresine veya posta adresine gönderilen e-posta yoluyla kişisel verilerinizin muhalefeti ve taşınabilirliği: 
				Av. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, Barselona, İspanya.<br>
				Her iki durumda da kendinizi adınız ve soyadınızın yanı sıra gerekiyorsa DNI veya ulusal kimlik belgenizin bir kopyasıyla tanıtmanız gerekir.<br>
				Belirli bir amaç için onay vermiş olmanız durumunda, onayınızı istediğiniz zaman geri çekme hakkına sahipsiniz, 
				geri çekilmeden önceki rızaya dayalı tedavinin yasallığını etkilemez.<br>
				Ayrıca, Arka Planı Kaldır'ın verilerinizi işleme biçiminde bir sorun olduğunu düşünüyorsanız, 
				şikayetlerinizi <a href="{aepdLink}">İspanya Veri Koruma Ajansı</a> olan ilgili <a href="{knowYourRightsLink}">veri koruma yetkilisine</a> yönlendirebilirsiniz. 
				İspanya örneğinde belirtilen.</p>


			<h3>4. Yaş</h3>
			<p>Çevrimiçi hizmetin kullanımıyla ilgili olarak, reşit olduğunuzu ve gerekli yasal gerekliliklere sahip olduğunuzu beyan edersiniz. 
				Bu sözleşmeye bağlı kalma ve siteyi tamamen sizin tarafınızdan kabul edilen hüküm ve koşullara uygun olarak kullanma kapasitesi 
				anlayın ve kabul edin.<br>
				Hizmete erişim için sağladığınız tüm bilgilerin kullanım öncesinde ve kullanım sırasında doğru ve eksiksiz olduğunu beyan edersiniz. 
				ve doğru.</p>


			<h3>5. Verilerin kullanımı</h3>
			<p>Arka Planı Kaldır, toplanan verileri aşağıdaki amaçlarla kullanacaktır:</p>
			<ul>
				<li>Hizmeti yönetin ve güncelleyin (yasal dayanak, Hizmeti sürdürmek ve sürdürmek konusundaki meşru menfaatimizdir) 
					güncel ve iyi durumda).</li>
				<li>Sorduğunuz soruları yanıtlayın (yasal dayanak, taleplere yanıt verme konusundaki meşru menfaatimizdir ve 
					kullanıcılarımızın şüpheleri).</li>
				<li>Yaptığınız ödemeleri işleme koyun (sözleşme yasal dayanaktır).</li>
				<li>Sözleşmeli hizmeti sağlayın (sözleşme yasal dayanaktır).</li>
				<li>Hizmetin güvenliğini koruyun, yasa dışı faaliyetleri araştırın, şartlar ve koşullarımızı uygulayın ve
					Devlet güvenlik güçlerine olası soruşturmalar çerçevesinde yardımcı olmak (yasal dayanağı bizim tarafımızdandır). 
					Hizmetin ve kullanıcılarının güvenliğini garanti etme ve sürdürme konusundaki meşru menfaat).</li>
			</ul>
			<p>Arka Planı Kaldır, temel kullanıcı profilleri oluşturabilmesine rağmen otomatik kararları kullanmaz. 
				yasal dayanak, ticari amaçlara yönelik meşru menfaatimiz ve kişiselleştirilmiş teklifler sunmamızdır.<br>
				Ayrıca Arka Planı Kaldır, toplu ve anonim veriler biçimindeki kullanıcı bilgilerini üçüncü taraflara göstermek için kullanabilir. 
				Ayrıca kullanıcılar ve onların Hizmeti kullanımları hakkındaki istatistikleri ve demografik bilgileri üçüncü taraflarla paylaşabilirsiniz. 
				Ancak bunların hiçbiri, söz konusu üçüncü tarafların kimliğinizi kişisel olarak tespit etmesine olanak sağlamaz.</p>

			<h5>5.1. E-postalarda ve iletişim formlarında</h5>
			<p>Web sitesi, kullanıcının kişisel verilerini standart iletişim formları aracılığıyla güvenli bir şekilde göndermesine olanak tanıyan bir SSL şifrelemesine sahiptir.<br>
				Toplanan kişisel veriler otomatik işleme tabi tutulacak ve ilgili dosyalara dahil edilecektir. 
				işleme faaliyetleri kaydının ve Arka Planı Kaldır'ın sahibi olduğu kayıttır.</p>
			<p>Bu anlamda:</p>
			<ul>
				<li>Size yeterli hizmeti sunmak amacıyla mesajın kaynağını doğrulamak için kullanılacak olan IP adresinizi alacağız. 
					tavsiyelerde bulunmak (örneğin, bilgiyi doğru dilde sunmak) ve olası usulsüzlükleri tespit etmek 
					(örneğin, Hizmete siber saldırı yapmaya yönelik olası girişimler) ve İSS'nizle ilgili veriler.</li>
				<li>Aynı şekilde, verilerinizi bize telefon, e-posta ve belirtilen diğer iletişim araçlarıyla da sağlayabilirsiniz.</li>
			</ul>
			<p>Kullanılan ödeme yöntemiyle ilgili olarak:</p>
			<ul>
				<li>Hizmetlerimizin sağlanmasına ilişkin ödeme hizmeti sağlayıcılarımız kredi veya banka kartıdır. 
					Hizmetin veya personelinin hiçbir zaman banka ayrıntılarına (örneğin, kredi kartı numarası) erişimi olmayacaktır. 
					Kullanıcının müşteri olarak bu üçüncü taraflara sağlayacağı bilgiler.</li>
			</ul>


			<h3>6. Veri saklama</h3>
			<p>Aşağıda Hizmet tarafından işlenen verilerin ne kadar süre saklanacağı belirtilmektedir:</p>
			<ul>
				<li>Ayrıştırılmış veriler herhangi bir silme süresi olmadan saklanacaktır.</li>
				<li>
					Müşteri verileri gereken minimum süre boyunca saklanacaktır ve şu tarihe kadar saklanabilir:
					<ul>
						<li>Maddeye göre 5 yıl. 1964 Medeni Kanun (özel süresi olmayan kişisel eylemler).</li>
						<li>Maddeye göre 6 yıl. Ticaret Kanunu'nun 30'u (örneğin muhasebe defterleri veya faturalar).</li>
					</ul>
				</li>
				<li>Kullanıcı verileri, isteklerinin yerine getirilebilmesi amacıyla maksimum 12 ay süreyle saklanacaktır.</li>
			</ul>


			<h3>7. Üçüncü taraflarla paylaşılan veriler</h3>
			<p>Hizmetin bir bölümünü yöneten üçüncü taraflar var.<br>
				Arka Planı Kaldırma, kendi Gizlilik Politikasına ek olarak, uygun olduğu şekilde bu Gizlilik Politikasına da uymalarını gerektirir. Ancak Arka Planı Kaldır, söz konusu politikaya uygunluktan sorumlu olmayacaktır.<br>
				Bazı durumlarda Arka Planı Kaldır, toplanan kişisel bilgilerin herhangi birini üçüncü taraflarla paylaşabilir, kullanabilir veya koruyabilir:</p>
			<ul>
				<li>Hizmeti sağlamak için:</li>
			</ul>
			<p>Ödeme hizmetleri, web barındırma, iş analitiği, müşteri hizmetleri veya web pazarlama gibi bizim adımıza işlevler gerçekleştiren hizmet sağlayıcılar. Bu hizmet sağlayıcılar, işlevlerini yerine getirmek için gerekli bilgileri toplayabilir ve bu bilgilere erişebilir, ancak bilgileri başka herhangi bir amaçla paylaşmalarına veya kullanmalarına izin verilmez.</p>
			<ul>
				<li>Yetkili makamlarla işbirliği yapmak için:</li>
			</ul>
			<p>Herhangi bir yasayı, yasal süreci veya meşru menfaati karşılamanın makul ölçüde gerekli olduğuna inanırsak. Her durumda, yalnızca kesinlikle gerekli olan bilgileri sağlayacağız.</p>


			<h3>8. Güvenlik önlemleri</h3>
			<p>Arka Planı Kaldır, aşağıdakileri gerçekleştirmek için gerekli tüm teknik ve organizasyonel önlemleri alır:
				Toplanan kişisel ve kişisel olmayan bilgilerin güvenliğini ve bütünlüğünü koruyun. 
				Hem yetkisiz erişime hem de kazara değiştirilmesine, kaybolmasına veya tahrip edilmesine karşı.<br>
				Her durumda Arka Planı Kaldır, toplanan bilgilerin mutlak güvenliğini garanti edemez, 
				bu nedenle, paylaşılan bilgiler konusunda her zaman işbirliği yapmalı ve sağduyunuzu kullanmalısınız.<br>
				Silindikten sonra bile kişisel ve kişisel olmayan bilgilerin silinebileceğini anlıyor ve kabul ediyorsunuz. 
				önbellekte veya diğer kullanıcıların kopyalayıp saklaması durumunda görünür durumda kalır.</p>


			<h3>9. Gizlilik Politikasındaki Değişiklikler</h3>
			<p>Bu Gizlilik Politikasını gelecekte güncelleyebiliriz. Belirtilen e-posta adresine bir bildirim göndererek ve/veya web sitemizde göze çarpan bir yere bir bildirim yerleştirerek sizi değişiklikler hakkında bilgilendireceğiz.</p>


			<h3>10. İletişim</h3>
			<p>Bu Gizlilik Politikasıyla ilgili sorularınız varsa bizimle şu adresten iletişime geçin:</p>
			<p>E-posta: {supportLink}<br> 
				Adres: Av. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, Barselona, İspanya.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Son güncelleme: 10 Haziran 2024',
		content: `
			<h3>1. Sorumlu kimdir ve onlarla nasıl iletişime geçilir?</h3>
			<p>Bu sitenin denetleyicisi, Av. adresindeki Remove Background S.L'dir. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, Barselona, İspanya.</p>
			<p>Onunla {supportLink} adresinden e-posta yoluyla iletişime geçebilirsiniz.</p>

			<h3>2. Hangi veriler toplanıyor?</h3>
			<p>
				Analizler de dahil olmak üzere cihazınıza yüklediğimiz çerezler aracılığıyla otomatik olarak veri topluyoruz. 
				Ayrıca bağlantının yapıldığı IP'yi, kullanılan cihazın tipini ve özelliklerini de topluyoruz, 
				işletim sisteminin sürümü, tarayıcının türü, dil, tarih, ülke, isteğin saati, 
				diğerlerinin yanı sıra geldiğiniz URL, gittiğiniz URL veya kullanılan mobil ağ.<br>
				Kullanıcı, gönüllü olarak bize adı ve soyadı, e-posta adresi veya banka bilgileri gibi bazı bilgileri sağlar. 
				bizimle iletişime geçebilmek, hizmete kaydolabilmek veya bir abonelik satın alabilmek için.
			</p>

			<h3>3. Toplanan veriler ne için kullanılıyor?</h3>
			<p>
				Hizmet, toplanan verileri diğer şeylerin yanı sıra hizmeti yönetmek ve güncellemek, isteklerinize yanıt vermek, 
				bültenimizi ve promosyon tekliflerimizi size e-postayla göndermek, platformdaki kaydınızı yönetmek, yönetmek ve sağlamak 
				Aboneliğinizle ilgili hizmetleri, yaptığınız ödemeleri işleme koymayı ve ilgili faturaları düzenlemeyi, 
				Hizmetin güvenliğini korumak, yasa dışı faaliyetleri araştırmak, şart ve koşullarımızı uygulamak ve 
				Devlet güvenlik güçlerine ve organlarına nihai soruşturmalar çerçevesinde yardım etmek.
			</p>

			<h3>4. Ne kadar süreyle saklanıyorlar?</h3>
			<ul>
				<li>Ayrıştırılmış veriler herhangi bir silme süresi olmadan saklanacaktır.</li>
				<li>
					Müşteri verileri gereken minimum süre boyunca saklanacaktır ve şu tarihe kadar saklanabilir:
					<ul>
						<li>Maddeye göre 5 yıl. 1964 Medeni Kanun (özel süresi olmayan kişisel eylemler).</li>
						<li>Maddeye göre 6 yıl. Ticaret Kanunu'nun 30'u (örneğin muhasebe defterleri veya fatura).</li>
					</ul>
				</li>
				<li>Kullanıcı verileri, isteklerinin yerine getirilmesi amacıyla maksimum 12 ay süreyle saklanacaktır.</li>
				<li>Hizmet tarafından sosyal ağlardaki sayfalara ve profillere yüklenen kullanıcı verileri, kullanıcının onay verdiği andan itibaren geri çektiği ana kadar saklanacaktır.</li>
			</ul>

			<h3>5. Kullanıcı olarak haklarınız nelerdir?</h3>

			<p>
				Erişim hakkı: Etkilenen taraf, veri kontrolöründen erişim hakkı olup olmadığı konusunda onay alma hakkına sahip olacaktır. 
				kendisine ait kişisel veriler işlenmemektedir.
			</p>
			<p>
				Düzeltme hakkı: Etkilenen taraf, herhangi bir gecikme olmaksızın veri kontrolöründen bilgi alma hakkına sahip olacaktır. 
				Yanlış olan ve kendisini doğrudan etkileyen kişisel verilerin düzeltilmesi. Aynı şekilde ilgili taraf da 
				Ek bir beyan yoluyla da dahil olmak üzere, eksik kişisel verileri tamamlama hakkına sahiptir.
			</p>
			<p>
				Silme hakkı: Etkilenen tarafın, gereksiz bir gecikme olmaksızın, veri sorumlusundan silme işlemini talep etme hakkıdır. 
				kendisini ilgilendiren kişisel verilerden.
			</p>
			<p>
				Veri işlemeyi sınırlama hakkı: Verilerinizin sorumlu kişi tarafından işlenmesinin sınırlandırılmasının sağlanmasından ibarettir, 
				uygulanmasının iki yönü olmasına rağmen: 1) İzin verilen bir süre boyunca kişisel verilerinizin doğruluğuna itiraz ettiğinizde 
				bunu doğrulamak için sorumlu kişi ve 2) Sorumlu kişinin kişisel verilerinizin işlenmesine itiraz ettiğinizde 
				Meşru menfaate veya kamu menfaatine dayalı bir misyona dayalı olarak gerçekleştirilirken, sorumlu kişi bu sebeplerin olup olmadığını doğrular. 
				seninkine galip gel.
			</p>
			<p>
				Veri taşınabilirliği hakkı: Etkilenen tarafın kendisini ilgilendiren kişisel verileri alma hakkıdır, 
				Veri sorumlusuna, ortak kullanım ve mekanik okuma için yapılandırılmış bir formatta sağladığı ve 
				bunların sağlandığı kontrolör tarafından engellenmeksizin başka bir kontrolöre iletilmesi.
			</p>
			<p>
				Bu anlamda ilgili taraf, kişisel verilerinin doğrudan veri sorumlusundan iletilmesini sağlama hakkına sahip olacaktır. 
				Teknik olarak mümkün olduğunda kontrolöre.
			</p>

			<h3>6. Haklarınızı nasıl kullanabilirsiniz?</h3>

			<p>
				Kişisel veri haklarınızı istediğiniz zaman şu adrese e-posta göndererek kullanabilirsiniz: {supportLink} Veya şu posta adresine: 
				Av. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, Barselona, İspanya. Her iki durumda da kendinizi adınız ve soyadınızla tanımlamanız, 
				ve gerekirse DNI'nızın veya ulusal kimliğinizin bir kopyası.<br>
				Ayrıca, Arka Planı Kaldır'ın verilerinizi işleme biçiminde bir sorun olduğunu düşünüyorsanız hak taleplerinizi yönlendirebilirsiniz. 
				<a href="{aepdLink}">İspanya Veri Koruma Dairesi</a> olan <a href="{knowYourRightsLink}">veri koruma yetkilisine</a> 
				İspanya örneğinde belirtilen.
			</p>

			<h3>7. Güvenlik önlemleri alındı mı?</h3>
			<p>
				Hizmet, kişisel bilgilerin güvenliğini ve bütünlüğünü korumak için gerekli tüm teknik ve organizasyonel önlemleri alır. 
				ve toplanan kişisel olmayan bilgiler. Hem yetkisiz erişime hem de kazara yapılan değişikliklere, kaybolmaya veya tahrip edilmeye karşı.<br>
				Her durumda Hizmet, toplanan bilgilerin mutlak güvenliğini garanti edemez; bu nedenle işbirliği yapmanız ve 
				Paylaşılan bilgilerle ilgili olarak her zaman sağduyunuzu kullanın.<br>
				Kişisel ve Kişisel Olmayan Bilgilerin, silindikten sonra bile önbellekte veya önbellekte görüntülenebileceğini anlıyor ve kabul ediyorsunuz. 
				diğer kullanıcılar tarafından kopyalanır veya saklanırsa.
			</p>

			<h3>8. Kişisel verilerin aktarımı veya uluslararası aktarımlar var mı?</h3>

			<p>
				Verileri veya uluslararası aktarımları aktarmıyoruz. Ancak Hizmetin bir kısmını yöneten üçüncü taraflar vardır 
				kendileri için geçerli olduğu ve onların da kendilerine ait olduğu sürece Gizlilik Politikamıza uymamız gerektiğini. 
				Bu üçüncü taraflar, web barındırma gibi bizim adımıza işlevleri yerine getiren hizmet sağlayıcılardır. 
				analiz izleme veya web geliştirme.<br>
				Ayrıca herhangi bir yasayı, yasal süreci veya meşru menfaati karşılamanın makul olarak gerekli olduğuna inanırsak. 
				Her durumda, yalnızca kesinlikle gerekli olan bilgileri sağlayacağız.
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: 'Son güncelleme: 21 Haziran 2024',
		content: `
			<h3>Özet</h3>
			<ul>
			    <li>Kullanılan çerezler: <strong>Kendi ve Üçüncü Taraf</strong></li>
			    <li>İstatistik elde etmek için kullanılıyorlar mı? <strong>Evet, hizmeti daha iyi yönetme konusundaki meşru menfaatimize dayanmaktadır.</strong></li>
			    <li>Bu web sitesi aracılığıyla çerez yükleyen üçüncü taraf hizmetler: <strong>Google, Google Analytics, Cloudflare ve Stripe.</strong></li>
			</ul>

			<h3>Çerezler nasıl yapılandırılır ve devre dışı bırakılır</h3>
			<p>
			    Cihazınıza yüklenen çerezlere web tarayıcınızdan izin verebilir, engelleyebilir veya silebilirsiniz. Cihazınıza çerezlerin kurulmasına izin vermiyorsanız, 
			    tarama deneyimi kötüleşebilir. Aşağıda her tarayıcıda çerezleri nasıl yapılandıracağınızı bulabilirsiniz:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Kenar</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Türler ve Kullanımlar</h3>
			<p>Hizmet, gezinmeyi geliştirmek, hizmeti sağlamak ve web sitesinin kullanımına ilişkin istatistikler elde etmek için kendisine ait ve üçüncü taraf çerezlerini kullanır.</p>

			<h3>2. Çerez nedir ve ne için kullanılır?</h3>
			<p>
			    Çerez, bilgisayarınıza, mobil cihazınıza veya tabletinizin web tarayıcısına gönderilen ve bunlar hakkında bilgi depolamak ve almak için kullanılan bir metin dosyasıdır.
			    tarama tamamlandı. Örneğin, kullanıcı adınızı ve şifrenizi veya profil tercihlerinizi hatırlamak için.
			</p>

			<h3>3. Ne tür çerezler vardır?</h3>
			<p>Onları kimin yönettiğine göre:</p>
			<ul>
			    <li>Kendi çerezlerimiz; tarayıcınıza kendi ekipmanlarımızdan veya web alan adlarımızdan gönderilirler.</li>
			    <li>Üçüncü taraf çerezleri; tarayıcınıza doğrudan yönetmediğimiz ekipmanlardan veya web etki alanlarından, ancak Google gibi üçüncü bir kuruluş tarafından gönderilirler.</li>
			</ul>
			<p>Ne kadar süre aktif kaldıklarına bağlı olarak aşağıdakiler vardır:</p>
			<ul>
			    <li>Oturum çerezleri; siz web sitesinden ayrılana kadar tarayıcınızın çerez dosyasında kalırlar, dolayısıyla hiçbiri cihazınızda kalmaz.</li>
			    <li>Kalıcı çerezler; cihazınızda kalırlar ve web sitemiz her yeni ziyaretinizde bunları okur. Bu çerezler belirli bir tarihten sonra çalışmayı durdurur.</li>
			</ul>
			<p>Son olarak amaçlarına göre elimizde:</p>
			<ul>
			    <li>Teknik çerezler; gezinmeyi ve web sitesinin düzgün çalışmasını iyileştirirler.</li>
			    <li>Kişiselleştirme çerezleri; bir dizi kritere göre önceden tanımlanmış özelliklere sahip hizmete erişime izin verirler.</li>
			    <li>Analitik çerezler; sağlanan hizmetin kullanımının ölçülmesine ve istatistiksel olarak analiz edilmesine olanak tanır.</li>
			</ul>
			<p><strong>remove-background.com</strong></p> tarafından kullanılan üçüncü taraf çerezlerin listesi
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Çerezleri (NID veya CONSENT), reklamların Google dışında nasıl görüneceğini kişiselleştirmeye veya bilgi depolamaya olanak tanır
			        örneğin arama sonuçlarını görüntülerken tercih edilen dil. Google'ın çeşitli hizmetlerinde kullandığı çerez türleri hakkında<br><a href="{externalLink: googleCookieTypes}">daha fazla bilgi</a>.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Çerezleri (_ga gibi), bir kullanıcının bir web sitesini kaç kez, nasıl, ne zaman ve nereden ziyaret ettiğini saymaya olanak tanır.<br>
			        Her durumda, Google Analytics çerezlerini <a href="{externalLink:disableGoogleAnalytics}">buradan</a> devre dışı bırakabilirsiniz.
			    </li>
			    <li>Cloudflare: Cloudflare'in çerez politikası ve kullanımı hakkında bilgi edinmek için <a href="{externalLink: cloudflareCookiesPolicy}">bu bağlantıya</a> tıklayın.</li>
			    <li>Stripe: Stripe'ın çerez politikası ve kullanımına ilişkin bilgileri <a href="{externalLink: stripeCookiesPolicy}">burada</a> bulabilirsiniz.</li>
			</ul>
		`
	}
};
